// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3qNCJ","productName":"Table_productName__3u-l6"};